(function () {
  function initFooterAccordion() {
    if (window.innerWidth > 749) return;

    const blocks = document.querySelectorAll('.footer-block');
    const accordionBlocks = ['Shop', 'Get to know us', 'Legal']; // Titel anpassen falls nötig

    blocks.forEach(function (block) {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;
      if (!accordionBlocks.includes(heading.textContent.trim())) return;

      const content = block.querySelector('.footer-block__details-content, .footer-block__list, ul');
      if (!content) return;

      // Bereits initialisiert?
      if (block.dataset.accordion === 'true') return;
      block.dataset.accordion = 'true';

      // Startzustand: eingeklappt
      content.style.display = 'none';
      heading.style.cursor = 'pointer';

      // Toggle-Indikator
      const indicator = document.createElement('span');
      indicator.className = 'footer-accordion-indicator';
      indicator.textContent = '+';
      indicator.style.cssText = 'float:right; font-size:1.2em; line-height:1; pointer-events:none;';
      heading.appendChild(indicator);

      heading.addEventListener('click', function () {
        const isOpen = content.style.display !== 'none';
        content.style.display = isOpen ? 'none' : 'block';
        indicator.textContent = isOpen ? '+' : '−';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();
